// Libraries
import _ from 'lodash';
import React from 'react';

// Supermove
import {Space, Styled, TimeInput} from '@supermove/components';
import {gql} from '@supermove/graphql';
import {Form, ResponsiveType} from '@supermove/hooks';
import {OrganizationModel} from '@supermove/models';
import {colors} from '@supermove/styles';

// App
import FieldInput from '@shared/design/components/Field/FieldInput';
import Text from '@shared/design/components/Text';

const Container = Styled.View`
`;

const EstimatedHoursRowContainer = Styled.View`
  flex-direction: row;
  align-items: center;
`;

const StartTimesField = ({
  field,
  form,
  organization,
  responsive,
}: {
  field: string;
  form: Form;
  organization: OrganizationModel;
  responsive: ResponsiveType;
}) => {
  const {errors, touched} = form;
  const errorMessage1 = _.get(errors, `${field}.startTime1`);
  const errorMessage2 = _.get(errors, `${field}.startTime2`);
  const isTouched1 = !!_.get(touched, `${field}.startTime1`);
  const isTouched2 = !!_.get(touched, `${field}.startTime2`);
  const error1 = isTouched1 && errorMessage1;
  const error2 = isTouched2 && errorMessage2;
  const errorMessage = error1 || error2;

  return (
    <Container>
      <EstimatedHoursRowContainer>
        <FieldInput
          {...form}
          index={1}
          component={TimeInput}
          name={`${field}.startTime1`}
          showErrorMessage={false}
          input={{
            required:
              organization.features.isEnabledJobStartTime1IsRequired &&
              !_.get(form.values, `${field}.startTime1`),
            component: FieldInput.TextInput,
            placeholder: 'Start',
            setFieldValue: form.setFieldValue,
            responsive,
          }}
          style={{
            flex: 1,
          }}
        />
        <Space width={8} />
        <Text.Body>-</Text.Body>
        <Space width={8} />
        <FieldInput
          {...form}
          index={2}
          component={TimeInput}
          name={`${field}.startTime2`}
          showErrorMessage={false}
          input={{
            component: FieldInput.TextInput,
            placeholder: 'End',
            setFieldValue: form.setFieldValue,
          }}
          style={{
            flex: 1,
          }}
        />
      </EstimatedHoursRowContainer>
      {errorMessage && (
        <React.Fragment>
          <Space height={4} />
          <Text.Body style={{color: colors.red.warning}}>{errorMessage}</Text.Body>
        </React.Fragment>
      )}
    </Container>
  );
};

// --------------------------------------------------
// Data
// --------------------------------------------------
StartTimesField.fragment = gql`
  fragment StartTimesField on Organization {
    id
    features {
      isEnabledJobStartTime1IsRequired: isEnabled(feature: "JOB_START_TIME_1_IS_REQUIRED")
    }
  }
`;

export default StartTimesField;
